import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWoman = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 19,
	viewBox: "0 0 12 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.25 6.375C11.25 3.28906 8.71094 0.75 5.625 0.75C2.5 0.75 0 3.28906 0 6.375C0 9.1875 1.99219 11.4922 4.6875 11.9219V14.1875H2.96875C2.69531 14.1875 2.5 14.4219 2.5 14.6562V15.5938C2.5 15.8672 2.69531 16.0625 2.96875 16.0625H4.6875V17.7812C4.6875 18.0547 4.88281 18.25 5.15625 18.25H6.09375C6.32812 18.25 6.5625 18.0547 6.5625 17.7812V16.0625H8.28125C8.51562 16.0625 8.75 15.8672 8.75 15.5938V14.6562C8.75 14.4219 8.51562 14.1875 8.28125 14.1875H6.5625V11.9219C9.21875 11.4922 11.25 9.1875 11.25 6.375ZM1.875 6.375C1.875 4.34375 3.55469 2.625 5.625 2.625C7.65625 2.625 9.375 4.34375 9.375 6.375C9.375 8.44531 7.65625 10.125 5.625 10.125C3.55469 10.125 1.875 8.44531 1.875 6.375Z",
		fill: "#C34849"
	})
});
export default SvgWoman;
